import { Trigger } from '@radix-ui/react-tooltip'

export const TooltipTrigger = Trigger
